module.exports = __webpack_public_path__ + "98fac877ba53e782edb01008cc41f4e2.pdf";